import React from "react";

const ProfileDropdownItem = ({ onClick, icon: Icon, label, variant = "default" }) => {
  const themes = {
    default: "text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-white/5",
    danger: "text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10"
  };

  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3 text-xs font-black uppercase tracking-widest rounded-xl transition-all ${themes[variant]}`}
    >
      <Icon size={16} />
      {label}
    </button>
  );
};

export default ProfileDropdownItem;